<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.22259 4.22221C4.65216 3.79263 5.34865 3.79263 5.77822 4.22221L12.0004 10.4444L18.2226 4.22221C18.6522 3.79263 19.3486 3.79263 19.7782 4.22221C20.2078 4.65178 20.2078 5.34827 19.7782 5.77784L13.556 12L19.7782 18.2222C20.2078 18.6518 20.2078 19.3483 19.7782 19.7779C19.3487 20.2074 18.6522 20.2074 18.2226 19.7779L12.0004 13.5557L5.77821 19.7779C5.34863 20.2074 4.65215 20.2074 4.22257 19.7779C3.793 19.3483 3.793 18.6518 4.22257 18.2222L10.4448 12L4.22259 5.77784C3.79301 5.34827 3.79301 4.65178 4.22259 4.22221Z" fill="#BD2B2B"/>
    </svg>
</template>
<script>
    export default {
        name: 'CloseXIcon'
    };
</script>